<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>보고서 의뢰 등록정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
              <tbody class="">
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">등록자</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_name}}</td>
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">등록일</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.reg_date}}</td>
                </tr>

                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">이메일</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_email}}</td>
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">휴대폰번호</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_phone}}</td>
                </tr>

                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">회사 정보</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_company}}</td>
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">직책 정보</label>
                  </td>
                  <td class="" style="vertical-align:middle">{{reqDatas.user_position}}</td>
                </tr>

                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">제목</label>
                  </td>
                  <td class="" colspan="3" style="vertical-align:middle">{{reqDatas.title}}</td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">내용</label>
                  </td>
                  <td class="" colspan="3" style="vertical-align:middle"><div v-html="reqDatas.contents"></div></td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>

        <b-card>
          <div slot="header">
            <strong>
              <div>보고서 의뢰 답변</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변자</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{userInfo.manager_id}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변상태</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{reqDatas.qastatus_name}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">제목</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" name="reply_title" type="text" v-model="queryParams.reply_title" v-validate="'required'" :class="{'is-invalid': errors.has('reply_title')}"></b-form-input>
                            <span v-show="errors.has('reply_title')" :class="{error: errors.has('reply_title')}">제목명은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">내용</label>
                      </td>
                      <td class="">
                        <vue-ckeditor v-model="queryParams.reply_contents" :config="config" />
                      </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:80%">
              <b-row>
                <b-col md="4"><!-- 1:응대대기, 2:응대완료, 3:임시저장 -->
                  <!-- <b-button variant="secondary" v-on:click="saveRequestRe(3)" style="color:#ffffff; border-radius:5px; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 임시저장</h5></b-button> -->
                </b-col>
                <b-col md="4">
                  <b-button variant="success" style="color:#ffffff; border-radius:5px; width:100%; border:1px solid #248847; font-size:15px"
                            v-on:click="saveRequestRe(2)" ><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; width:100%; border:1px solid #187c9f; font-size:15px"
                            v-bind:href="'#/customer/reportrequestpublic'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import datetimepicker from "daterangepicker/daterangepicker.js";
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import VueCkeditor from 'vue-ckeditor2';
// import draggable from "vuedraggable";
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    Multiselect,
    // draggable,
    // vueDropzone: vue2Dropzone,
    VueCkeditor,
  },
  data() {
    return {
      reqCode: '',
      pageOptions: [5, 10, 30, 50, 100],
      formtype: 'insert',
      items: [],
      userInfo: {},
      reqDatas: {
        // attachmentFileItems:[],
      },
      queryParams: {
        // reg_date: moment().format('YYYY-MM-DD'),
        // attachmentFileItems:[],
        use_yn: 'Y',
        top_yn: 'N',
        reply_title: '',
      },
      enabled: true,
      isLoading: false,
      config: {
        toolbar:[
          { name: 'document', items: [ 'Source', 'Preview'] },
          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
          '-',
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
          { name: 'links', items: ['Link', 'Unlink'] },
          '/',
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'about', items: [ 'About' ] }
        ],
        font_names: 'Noto Sans KR/Noto Sans KR,sans-serif;맑은 고딕/Malgun Gothic;굴림/Gulim;돋움/Dotum;바탕/Batang;궁서/Gungsuh;',
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        uploadUrl: 'backend/ftpserver/ckeditImageUpload?command=QuickUpload&type=Files&responseType=json',
        height: 300,
        versionCheck: false,
        extraPlugins: 'tableresize'
      },
    }
  },
  watch: {
  },
  mounted: function() {
    var self = this;
    self.userInfo = self.$session.get('userInfo');
    self.reqCode = self.$session.get('reqCode');

    if(self.reqCode != undefined){
      self.getRequestData();
    }

  },
  methods: {
    // 문의 정보 조회
    getRequestData() {
      var self = this;
      self.queryParams.id = self.reqCode;

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/reportRequestData?access_token=' + token, data, null)
        .then((result) => {
          // result.data.attachmentFileItems.forEach(function (t_el, t_idx, t_arr){
          //   if(t_el.file_extensions == 'png' || t_el.file_extensions == 'jpg'){
          //     t_el.file_extensions = 'image';
          //   }
          // });

          console.log(result.data);
          self.reqDatas = result.data;
          self.queryParams.reply_title = "Re: " + self.reqDatas.title;
          // var fileItem =
          // self.queryParams.attachmentFileItems.push(self.reqDatas);

          if(self.reqDatas.reply_contents != null){
            self.formtype = 'update';
            self.queryParams = self.reqDatas.reply_contents;
          }

          // console.log("formtype",self.formtype);
      });
    },
    // 고객문의 답변 저장 및 수정
    saveRequestRe(qastatus) {
      var self = this;

      // 답변메일 로딩 추가
      if (self.isLoading){
        swal.fire({
          type: 'warning',
          title: '답변 메일이 전송중입니다.',
          showConfirmButton: false,
          timer: 1500
        })

        return
      }
      self.isLoading = true;

      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");

          self.queryParams.user_email = self.reqDatas.user_email;

          self.queryParams.reply_reg_user = self.userInfo.manager_id;
          self.queryParams.qastatus = qastatus;
          self.queryParams.reply_id = self.reqDatas.reply_id;

          if(self.queryParams.reply_contents == ""){
            swal.fire({
              type: 'warning',
              title: '내용 부분은 필수로 작성해 주세요.',
              showConfirmButton: true,
            })
            return false;
          }

          console.log(self.queryParams);
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);

          if(self.formtype == 'insert'){
            self.$http.post('/api/insert/reportRequestReply?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '답변이 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                    self.isLoading = false;
                    window.location = "#/customer/reportrequestpublic";
                });
            })
          }else if(self.formtype == 'update'){
            self.$http.post('/api/update/qaReply?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '답변을 수정하였습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    self.isLoading = false;
                    window.location = "#/customer/reportrequestpublic";
                });
            })
          }
        }
      })
    },
    /**
    * 이미지 파일 업로드
    */
    uploadSummernoteImageFile(file, editor) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var data = new FormData();
      data.append("file", file);

      self.$http.post('/ftpserver/editorImageUpload?access_token='+token, data, null)
      .then((result) => {
        $(editor).summernote('insertImage', result.data);
      })
    },
  }
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/customer/ReportRequestForm.vue